import * as types from './mutation-types'

export default {
  [types.SET_CATALOGO] (state, catalogo) {
    state.catalogo = catalogo
  },
  [types.SET_VALORES] (state, valores) {
    state.valores = valores
  },
  [types.SET_PRODUTO_ATIVO] (state, { chave, ativo }) {
    if (!state.valores[chave]) return
    state.valores[chave].ativo = ativo
  },
  [types.SET_CAMPO_VALOR] (state, { chave, campoChave, valor }) {
    if (!state.valores[chave]) return
    state.valores[chave].valor[campoChave] = valor
  },
  [types.SET_DADOS_RETORNO_CADASTRO] (state, dados) {
    state.dadosRetorno = {
      sucesso: dados.sucesso,
      mensagem: dados.mensagem,
      listaDeErros: dados.listaDeErros
    }
  },
  [types.SET_CARREGANDO_DADOS] (state, { status, mensagem }) {
    state.flagsDeControle.carregandoDados.status = status
    state.flagsDeControle.carregandoDados.mensagem = mensagem
  },
  [types.SET_MANIPULANDO_DADOS] (state, { status, mensagem }) {
    state.flagsDeControle.manipulandoDados.status = status
    state.flagsDeControle.manipulandoDados.mensagem = mensagem
  }
}
